import React from "react";

const STEPS = [
  { id: "edit", label: "Edit Invitation" },
  { id: "preview", label: "Preview" },
  { id: "details", label: "Finalize Details" },
  { id: "theme", label: "Choose Theme" },
  { id: "guests", label: "Manage Guests" },
];

export function WorkflowSteps({ currentStep }) {
  const currentIndex = STEPS.findIndex((step) => step.id === currentStep);

  return (
    <div className="rounded-[26px] border border-[#ead9e7] bg-white/85 px-4 py-4 shadow-[0_16px_40px_rgba(125,70,105,0.06)] backdrop-blur md:px-5">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#b07c98]">
            Setup Progress
          </p>
          <p className="mt-1 text-sm text-[#7e6777]">
            Complete the invitation flow step by step.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {STEPS.map((step, index) => {
            const isCurrent = step.id === currentStep;
            const isCompleted = currentIndex > -1 && index < currentIndex;

            return (
              <React.Fragment key={step.id}>
                <div
                  className={`flex items-center gap-2 rounded-full px-3 py-2 text-xs font-bold uppercase tracking-[0.18em] ${
                    isCurrent
                      ? "bg-[#ff0099] text-white shadow-lg shadow-[#ff0099]/20"
                      : isCompleted
                        ? "bg-[#fff1f8] text-[#a52b69]"
                        : "bg-[#f7f1f5] text-[#b497a8]"
                  }`}
                >
                  <span
                    className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] ${
                      isCurrent
                        ? "bg-white/20 text-white"
                        : isCompleted
                          ? "bg-white text-[#a52b69]"
                          : "bg-white text-[#b497a8]"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span>{step.label}</span>
                </div>
                {index < STEPS.length - 1 ? (
                  <span className="hidden text-[#d0bec9] md:inline">/</span>
                ) : null}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}
